import z from "zod";

export const sentryConfigSchema = z.object({
  VITE_SENTRY_DSN: z.string().optional().default(""),
  VITE_SENTRY_EDITOR: z.enum(["antigravity", "vscode"]).default("vscode"),
  VITE_SENTRY_ROOT_PATH: z.string().default(""),
  VITE_SENTRY_MODE: z
    .enum(["Development", "Production"])
    .default("Development"),
  VITE_SENTRY_ENVIRONMENT: z.string().default("Development"),
});
